import { HeaderComponent } from './header/header.component';
import { CardComponent } from './card/card.component';
import { ButtonComponent } from './button/button.component';
import { InputComponent } from './input/input.component';
import { FooterComponent } from './footer/footer.component';
import { LoaderComponent } from './loader/loader.component';

export const components: any[] = [
  HeaderComponent,
  CardComponent,
  ButtonComponent,
  InputComponent,
  FooterComponent,
  LoaderComponent
]

export * from '../components/header/header.component';
export * from '../components/card/card.component';
export * from '../components/button/button.component';
export * from '../components/input/input.component';
export * from '../components/loader/loader.component';
